import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatDateTime } from '../../../utils/utils';

class PromptTone extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            date: formatDateTime(Date.parse(new Date())),
            sound: true,
        };
    }

    componentDidMount() {
        this.timerID = setInterval(() => this.tick(), 1000);
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
    }

    tick() {
        this.setState({
            date: formatDateTime(Date.parse(new Date())),
        });
    }

    soundOpen = () => {
        this.setState({
            sound: !this.state.sound,
        });

        this.props.onChange(!this.state.sound);
    };

    /**
     * 渲染组件
     */
    render() {
        const { date, sound } = this.state;

        return (
            <div className={styles.timer}>
                <p className={styles.nowTime}>{date}</p>
                <p className={sound ? styles.sound : `${styles.sound} ${styles.noSound}`} onClick={this.soundOpen}>
                    声音提醒
                </p>
            </div>
        );
    }
}

PromptTone.propTypes = { onChange: PropTypes.func };

export default errorBoundary(PromptTone);
